export default __webpack_public_path__ + "static/media/success_icon.19af7646.svg";